import request from '@/utils/request'

// register
export function register(data) {
  return request({
    url: '/register',
    method: 'post',
    data: data,
    vconfig:{
      noBaseApi:true
    }
  })
}

// login
export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data: data,
    vconfig:{
      noBaseApi:true,
      noErr:true,
    }
  })
}

// get login user info
export function getInfo() {
  return request({
    url: '/api/user/currentUser',
    method: 'get'
  })
}

// get captcha
export function getCodeImg() {
  return request({
    url: '/common/captcha',
    method: 'get',
    vconfig:{
      noErr:true,
      noBaseApi:true
    }
  })
}

// refresh token
export function checkStatus(param) {
  return request({
    url: '/checkStatus',
    method: 'get',
    params:param,
    vconfig:{
      noBaseApi:true,
      noErr:true,
    }
  })
}

// block Num
export function blockNum(param) {
  return request({
    url: '/bcinfo/blockNum',
    method: 'get',
    params:param,
    vconfig:{
      noBaseApi:true,
    }
  })
}

// producer Count
export function producerCount(param) {
  return request({
    url: '/bcinfo/producerCount',
    method: 'get',
    params:param,
    vconfig:{
      noBaseApi:true,
    }
  })
}
// TATCount Count
export function TATCount(param) {
  return request({
    url: '/bcinfo/TATCount',
    method: 'get',
    params:param,
    vconfig:{
      noBaseApi:true,
    }
  })
}
// USPCount Count
export function USPCount(param) {
  return request({
    url: '/bcinfo/USPCount',
    method: 'get',
    params:param,
    vconfig:{
      noBaseApi:true,
    }
  })
}
// peer count
export function peerCnt(param) {
  return request({
    url: '/bcinfo/peerCnt',
    method: 'get',
    params:param,
    vconfig:{
      noBaseApi:true,
    }
  })
}
// well count
export function wellCnt(param) {
  return request({
    url: '/bcinfo/wellCnt',
    method: 'get',
    params:param,
    vconfig:{
      noBaseApi:true,
    }
  })
}


// ----------------------------------------
export function getNonce (query) {
  console.log(query)
  return request ({
    url: '/api/getNonce',
    method: 'get',
    params:query
  });
}

export function getAccountList (address) {
  return request ({
    url: '/api/getAccountList?address=' + address,
    method: 'get',
  });
}

export function handleLogin (data) {
  return request ({
    url: '/api/login',
    method: 'post',
    data,
  });
}

// 获取合约地址和abi
export function getContract (name) {
  return request ({
    url: `/api/contracts/abi?name=${name}`,
    method: 'get',
  });
}

